<flx-flex-container>
	<flx-heading type="page" size="medium">Search</flx-heading>
	<form [formGroup]="bf.bigForm">
		<flx-search-bar [minLength]="minLength" formControlName="search" (clear)="clearSearch()" (doSearch)="doSearch()"></flx-search-bar>
	</form>
</flx-flex-container>
